import React from 'react';
import styled from 'styled-components';
var TitleContainer = styled.div.withConfig({
  displayName: "SimpleHeader__TitleContainer",
  componentId: "sc-1siuwbu-0"
})(["padding:0;position:relative;text-align:center;margin-top:", ";@media screen and (min-width:800px){margin-top:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.mediumSpacing;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.largeSpacing;
});
var Title = styled.h1.withConfig({
  displayName: "SimpleHeader__Title",
  componentId: "sc-1siuwbu-1"
})(["letter-spacing:1.5px;color:", ";text-transform:", ";display:inline-block;font-size:32px;line-height:1.2;text-align:center;margin:0 auto 0 auto;max-width:90%;position:relative;z-index:2;@media screen and (min-width:800px){font-size:60px;}@media screen and (min-width:960px){width:920px;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.textColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.uppercaseTitles ? 'uppercase' : 'none';
});
export default (function (_ref5) {
  var article = _ref5.article;
  var title = article.title;
  return React.createElement(TitleContainer, null, React.createElement(Title, null, title));
});